import React, { useState, useRef, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsX } from "react-icons/bs";
import { Dropdown } from "react-bootstrap";
import ReactTooltip from "react-tooltip";
import { Link } from "react-router-dom";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { IoIosClose } from "react-icons/io";
import { Modal } from "react-bootstrap";
import { editCompany } from "../../stores/services/company.service";
import { useSelector } from "react-redux";
import { fundCategoryTypeArr } from "../../utils/customFunction";
import { FiUploadCloud } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import { getAllUsers } from "../../stores/services/user.service";

function EditCompany({
  setEditModalFlag,
  selectedItems,
  setRefreshData,
  refreshData,
}) {
  const history = useHistory();
  const [image, setImage] = useState<any>("");
  const inputRefUser = useRef<HTMLInputElement>(null);
  const [profilePicture, setProfilePicture] = useState<any>();
  const [showImage, setShowImage] = useState<boolean>(false);
  const [onhover, setOnhover] = useState<boolean>(false);
  const [showModal, setShowModal] = useState(false);
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const [companySignatoryModal, setCompanySignatoryModal] = useState(false);
  const amcCodeRegex = new RegExp("^[A-Z]{1,5}[A-Z]{1,5}$");
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const [amcName, setAmcName] = useState("");
  const [amcCode, setAmcCode] = useState("");
  const [focalPerEmail, setFocalPerEmail] = useState("");
  const [focalPerName, setFocalPerName] = useState("");
  const [accTitle, setAccTitle] = useState("");
  const [accNo, setAccNo] = useState("");
  const [bankname, setBankName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [revenueAuthority, setRevenueAuthority] = useState("");
  // const [amcSig, setAmcSig] = useState<any[]>([]);
  const [conOffericer, setConOfficer] = useState("");
  const [Suboffericer, setSubOffericer] = useState("");
  const [txCreaterPop, setTxCreaterPop] = useState(false);
  let date = new Date();
  const [phone, setPhone] = useState("");
  const [mobile, setMobile] = useState("");
  const email = sessionStorage.getItem("email") || "";
  //foor Errors
  const [amcNameError, setAmcNameError] = useState("");
  const [amcCodeError, setAmcCodeError] = useState("");
  const [focalPerEmailError, setFocalPerEmailError] = useState("");
  const [focalPerNameError, setFocalPerNameError] = useState("");
  const [amcSigError, setAmcSigError] = useState("");
  const [revenueAuthorityError, setRevenueAuthorityError] = useState("");
  const [conOffericerError, setConOfficerError] = useState("");
  const [SuboffericerError, setSubOffericerError] = useState("");
  const [txCreaterError, setTxCreaterError] = useState("");
  const [txExeError, setTxExeError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [accTitleError, setAccTitleError] = useState("");
  const [accNoError, setAccNoError] = useState("");
  const [bankNameError, setBankNameError] = useState("");
  const [branchNameError, setBranchNameError] = useState("");
  const [billingName, setBillingName] = useState("");
  const [billingEmail, setBillingEmail] = useState("");
  const [billingDesignation, setBillingDesignation] = useState("");
  const [billingContactNumber, setBillingContactNumber] = useState("");
  const [Ntn, setNtn] = useState("");
  const [emailAdd, setEmailAdd] = useState("");
  const [nameCompanySignatory, setNameCompanySignatory] = useState("");
  const [emailCompanySignatory, setEmailCompanySignatory] = useState("");
  const [creatorEmailArray, setCreatorEmailArray] = useState<any>([]);
  const [billingNameErr, setBillingNameErr] = useState("");
  const [billingEmailErr, setBillingEmailErr] = useState("");
  const [billingDesignationErr, setBillingDesignationErr] = useState("");
  const [billingContactNumberErr, setBillingContactNumberErr] = useState("");
  const [NtnErr, setNtnErr] = useState("");
  const [name, setName] = useState<string>("");
  const [allBillingContact, setAllBillingContact] = useState<any>([]);
  const [modalView, setModalView] = useState(false);
  const [disableAddBtn, setDisableAddBtn] = useState<boolean>(false);
  const [fundTypeIs, setFundTypeIs] = useState<any>("");
  const [psxListing, setPsxListing] = useState(true);
  const [userIs, setUserIs] = useState<any>("");
  const [allExistingUsers, setAllExistingUsers] = useState<any>([]);

  useEffect(() => {
    if (selectedItems) {
      if (selectedItems?.company_logo) {
        setShowImage(true);
      }
      setImage(selectedItems?.company_logo || "");
      setAmcCode(selectedItems.company_code);
      setAmcName(selectedItems.name_of_company);
      setNtn(selectedItems.ntn);
      setAccTitle(selectedItems.account_title);
      setAccNo(selectedItems.IBAN);
      setCreatorEmailArray(selectedItems.txn_creator_field);
      setCompanySignatoryArray(selectedItems.amc_signatories);
      setFocalPerName(selectedItems.company_focal_name);
      setFocalPerEmail(selectedItems.company_focal_email);
      setMobile(selectedItems.mobile);
      setPhone(selectedItems.phone);
      setAllBillingContact(selectedItems.billing_contact);
      setFundTypeIs(selectedItems?.company_type);
    }
  }, [selectedItems]);

  const fetchAllUsers = async () => {
    try {
      const response = await getAllUsers(email, "all");
      if (response.data.status == 200) {
        setAllExistingUsers(response?.data?.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchAllUsers();
  }, []);

  const validate = () => {
    let amcErr,
      codeErr,
      personErr,
      perName,
      phoneErr,
      mobileErr,
      sigErr,
      offErr = "";

    let subOffErr,
      txCreaterErr,
      txExeErr,
      accTitleErr,
      accNoErr,
      banknameErr,
      branchNameErr,
      revAuth = "";

    amcName.trim() === "" ? (amcErr = "Required") : (amcErr = "");
    amcCode.trim() === ""
      ? (codeErr = "Required")
      : amcCodeRegex.test(amcCode) !== true
      ? (codeErr = "Invalid")
      : (codeErr = "");
    // focalPerEmail.trim() === '' ? personErr = "Required" : emailRegex.test(focalPerEmail) !== true ? personErr = 'Invalid Email' : personErr = "";
    // focalPerName.trim() === '' ? perName = "Required" : perName = "";
    emailArray.length === 0 ? (sigErr = "Required") : (sigErr = "");
    accTitle.trim() === "" ? (accTitleErr = "Required") : (accTitleErr = "");
    accNo.trim() === "" ? (accNoErr = "Required") : (accNoErr = "");
    bankname.trim() === "" ? (banknameErr = "Required") : (banknameErr = "");
    branchName.trim() === ""
      ? (branchNameErr = "Required")
      : (branchNameErr = "");
    // phone.trim() === '' ? phoneErr = "Required" : phoneErr = "";
    // mobile.trim() === '' ? mobileErr = "Required" : mobileErr = "";
    conOffericer.trim() === "" ? (offErr = "Required") : (offErr = "");
    Suboffericer.trim() === "" ? (subOffErr = "Required") : (subOffErr = "");
    revenueAuthority.trim() === "" ? (revAuth = "Required") : (revAuth = "");
    creatorEmailArray.length === 0
      ? (txCreaterErr = "Required")
      : (txCreaterErr = "");

    if (
      amcErr ||
      codeErr ||
      personErr ||
      perName ||
      sigErr ||
      phoneErr ||
      mobileErr ||
      offErr ||
      subOffErr ||
      txCreaterErr ||
      accTitleErr ||
      accNoErr ||
      banknameErr ||
      branchNameErr ||
      revAuth
    ) {
      setAmcNameError(amcErr);
      setPhoneError(phoneErr);
      setMobileError(mobileErr);
      setBankNameError(banknameErr);
      setBranchNameError(branchNameErr);
      setAccNoError(accNoErr);
      setAccTitleError(accTitleErr);
      setAmcCodeError(codeErr);
      setFocalPerEmailError(personErr);
      setFocalPerNameError(perName);
      setAmcSigError(sigErr);
      setConOfficerError(offErr);
      setSubOffericerError(subOffErr);
      setTxCreaterError(txCreaterErr);
      setTxExeError(txExeErr);
      setRevenueAuthorityError(revAuth);

      return false;
    } else {
      return true;
    }
  };
  const UpdateCompany = async () => {
    // const isValid = validate();
    if (fundTypeIs === "") {
      toast.error("Type should not be empty");
      return;
    }
    if (accNo === "" || accTitle == "") {
      toast.error("Account Title and IBAN should not be empty");
      return;
    }
    if (amcName === "" || amcCode === "") {
      toast.error("Company Code and Name of Company should not be empty");
      return;
    }
    if (creatorEmailArray?.length === 0) {
      toast.error("Kindly add Transaction Authorizor Field");
      return;
    }
    if (companySignatoryArray?.length === 0) {
      toast.error("Kindly add Company Signatories");
      return;
    }
    setLoading(true);
    let updateObj = {
      amc_code: amc_code,
      company_code: amcCode,
      name_of_company: amcName,
      tax_collector: revenueAuthority,
      ntn: Number(Ntn),
      account_title: accTitle,
      IBAN: accNo,
      txn_creator_field: creatorEmailArray,
      amc_signatories: companySignatoryArray,
      concerned_officer: "",
      substitude_concerned_officer: "",
      company_focal_name: focalPerName,
      company_focal_email: focalPerEmail,
      mobile: mobile,
      phone: phone,
      billing_contact: allBillingContact,
      company_type: fundTypeIs || "",
    };
    try {
      const response = await editCompany(email, selectedItems?._id, updateObj);
      if (response.data.status === 200) {
        toast.success(response.data.message);
        setEditModalFlag(false);
        setRefreshData(!refreshData);
      } else {
        toast.error(response.data.message);
      }
    } catch (err: any) {
      if (err.response !== undefined) {
        toast.error(err.response.data.message);
      } else {
        toast.error(err.message);
      }
    }
    setLoading(false);
  };
  const [officerData, setOfficerData] = useState<any>([]);
  const [Loading, setLoading] = useState(false);
  const renderofficersDropdown = () => {
    return officerData.map((item: any, index: string) => {
      return (
        <option key={index} value={item.email}>
          {item.name}
        </option>
      );
    });
  };

  //render dropdown for amc data
  const renderSubOfficerDropdown = () => {
    return officerData.map((item: any, index: string) => {
      return (
        <option key={index} value={item.email}>
          {item.name}
        </option>
      );
    });
  };
  const [emailArray, setEmailArray] = useState<any>([]);
  const [companySignatoryArray, setCompanySignatoryArray] = useState<any>([]);

  const removeEmail = (obj: object) => {
    const newArray = companySignatoryArray?.filter((object) => object !== obj);
    setEmailArray(newArray);
  };
  const removeCreatorCEmail = (obj: object) => {
    const newArray = creatorEmailArray.filter((object) => object !== obj);
    setCreatorEmailArray(newArray);
  };

  const changeCodeValue = (value: any) => {
    setAmcCode(value);
    if (value.trim() === "") {
      setAmcCodeError("Required");
    } else {
      amcCodeRegex.test(value) !== true
        ? setAmcCodeError("Invalid")
        : setAmcCodeError("");
    }
  };
  const renderBillingDataInTable = () => {
    return allBillingContact.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td>{items.name}</td>
          <td>{items.email}</td>
          <td className="text-right">{items.designation}</td>
          <td className="text-right">{items.contact_no}</td>
          <td className="text-right">
            <IoIosClose
              style={{ fontSize: "25px", color: "red" }}
              onClick={() => {
                let array = [...allBillingContact];
                array.splice(index, 1);
                setAllBillingContact(array);
              }}
            />
          </td>
        </tr>
      );
    });
  };
  const billingContactValidate = () => {
    let billingNameError,
      billingEmailError,
      billingDesignationError,
      billingContactNumberError = "";

    billingContactNumber.trim() === ""
      ? (billingContactNumberError = "Required")
      : (billingContactNumberError = "");
    billingEmail.trim() === ""
      ? (billingEmailError = "Required")
      : (billingEmailError = "");
    billingDesignation.trim() === ""
      ? (billingDesignationError = "Required")
      : (billingDesignationError = "");
    billingName.trim() === ""
      ? (billingNameError = "Required")
      : (billingNameError = "");

    if (
      billingContactNumberError ||
      billingDesignationError ||
      billingEmailError ||
      billingNameError
    ) {
      setBillingContactNumberErr(billingContactNumberError);
      setBillingDesignationErr(billingDesignationError);
      setBillingEmailErr(billingEmailError);
      setBillingNameErr(billingNameError);
      setDisableAddBtn(false);
      return false;
    } else {
      return true;
    }
  };
  const renderModalPopup = () => {
    switch (modalView) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal90w"
            show={true}
            size="lg"
            backdrop={true}
            enforceFocus={false}
            onHide={() => {
              setModalView(false);
            }}
          >
            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setModalView(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up"> Add Billing Contact </h6>
            </div>

            <div className="modal-body">
              <Row>
                <Col md="6">
                  <div className="form-group  ">
                    <label>Name</label>
                    <div className="">
                      <input
                        type="text"
                        className={`form-control  w-100 ${
                          billingNameErr ? "required-border" : ""
                        }`}
                        value={billingName}
                        onChange={(e) => {
                          setBillingName(
                            e.target.value.replace(/[^a-z^A-Z ]/, "")
                          );
                          setBillingNameErr("");
                        }}
                      />
                    </div>
                  </div>

                  <div className="form-group  ">
                    <label>Designation</label>
                    <div className="">
                      <input
                        type="text"
                        className={`form-control  w-100 ${
                          billingDesignationErr ? "required-border" : ""
                        }`}
                        value={billingDesignation}
                        onChange={(e) => {
                          setBillingDesignation(e.target.value);
                          setBillingDesignationErr("");
                        }}
                      />
                    </div>
                  </div>
                </Col>

                <Col md="6">
                  <div className="form-group  ">
                    <label>Email</label>
                    <div className="">
                      <input
                        type="text"
                        className={`form-control  w-100 ${
                          billingEmailErr ? "required-border" : ""
                        }`}
                        value={billingEmail}
                        onChange={(e) => {
                          setBillingEmail(e.target.value);
                          setBillingEmailErr("");
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group  ">
                    <label>Contact Number</label>
                    <div className="">
                      <input
                        type="number"
                        className={`form-control  w-100 ${
                          billingContactNumberErr ? "required-border" : ""
                        }`}
                        value={billingContactNumber}
                        onChange={(e) => {
                          var num = e.target.value;
                          if (num.length > 12) {
                            num = num.substring(0, 12);
                          }
                          setBillingContactNumber(num);
                          setBillingContactNumberErr("");
                        }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="row">
                <div className="col-sm-12">
                  <button
                    className="btn btn-primary btn-block mt-2 w-100 px-3 rounded"
                    onClick={() => {
                      addBillingContact();
                    }}
                    disabled={Boolean(disableAddBtn)}
                  >
                    {disableAddBtn ? (
                      <>
                        <span
                          className="spinner-border login-txt spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <span className="login-txt"> Loading...</span>
                      </>
                    ) : (
                      <span>Add</span>
                    )}
                  </button>
                </div>
              </div>
            </div>
            {}
          </Modal>
        );
      default:
        return "";
    }
  };

  const addBillingContact = () => {
    setDisableAddBtn(true);
    let valid = billingContactValidate();
    if (valid) {
      const billing_contact = {
        name: billingName,
        email: billingEmail,
        contact_no: billingContactNumber,
        designation: billingDesignation,
      };
      let temp = allBillingContact;
      temp.push(billing_contact);
      setAllBillingContact([...temp]);
      setBillingName("");
      setBillingEmail("");
      setBillingDesignation("");
      setBillingContactNumber("");
      setModalView(false);
    } else {
      setDisableAddBtn(false);
    }
  };

  const addEmailInList = async () => {
    let temp = creatorEmailArray;
    let obj: any;
    if (userIs) {
      obj = {
        name: selectedUser?.label,
        email: selectedUser?.email?.toLowerCase(),
        role: "TXN_CREATOR",
      };
    } else {
      obj = {
        name: name,
        email: emailAdd.toLowerCase(),
        role: "TXN_CREATOR",
      };
    }
    temp?.push(obj);
    console.log("temp", temp);
    setCreatorEmailArray(temp);
    setShowModal(false);
    setName("");
    setEmailAdd("");
    setUserIs("");
    setPsxListing(true);
  };

  const submitAddAMCSignatory = async () => {
    let temp = companySignatoryArray;

    let obj: any;
    if (userIs) {
      obj = {
        name: selectedUser?.label,
        email: selectedUser?.email?.toLowerCase(),
      };
    } else {
      obj = {
        name: nameCompanySignatory,
        email: emailCompanySignatory?.toLowerCase(),
      };
    }

    temp.push(obj);
    setCompanySignatoryArray(temp);
    setCompanySignatoryModal(false);
    setEmailCompanySignatory("");
    setNameCompanySignatory("");
    setUserIs("");
    setPsxListing(true);
  };

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
        ? "hsla(291, 64%, 42%, 1)"
        : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
        ? "#2b3553"
        : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  const renderFundTypeDropdown = () => {
    return fundCategoryTypeArr?.map((item) => {
      return {
        value: item,
        label: item,
      };
    });
  };

  const selectedTypeFund = React.useMemo(() => {
    return fundTypeIs
      ? {
          value: fundTypeIs,
          label: fundTypeIs,
        }
      : null;
  }, [fundTypeIs]);

  const renderUsersDropdown = () => {
    return allExistingUsers?.map((item) => {
      return {
        value: item?._id,
        label: item?.name,
        email: item?.email,
      };
    });
  };

  const selectedUser = React.useMemo(() => {
    const existUser = allExistingUsers?.find((ele) => ele?._id === userIs);
    return existUser
      ? {
          value: existUser?._id,
          label: existUser?.name,
          email: existUser?.email,
        }
      : null;
  }, [userIs]);

  return (
    <>
      <div className="content">
        {/* ------------- Transaction Creator Modal ------------------------ */}
        <Modal
          centered={true}
          className=""
          dialogClassName="modal60w"
          show={showModal ? true : false}
          size="lg"
          backdrop={true}
          onHide={() => {
            setShowModal(false);
            setName("");
            setUserIs("");
            setEmailAdd("");
            setPsxListing(true);
          }}
        >
          <div className="modal-header">
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                setName("");
                setEmailAdd("");
                setUserIs("");
                setShowModal(false);
                setPsxListing(true);
              }}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h6 className="title title-up">Transaction Creator</h6>
          </div>

          <div className="modal-body">
            <div className="mb-2">
              <form action="">
                <FormGroup check className="form-check-radio d-inline mr-3">
                  <Label check>
                    <Input
                      type="radio"
                      id="listed"
                      name="listed"
                      value="true"
                      checked={psxListing}
                      onClick={(e) => {
                        setPsxListing(true);
                        setName("");
                        setEmailAdd("");
                      }}
                    />
                    <span className="form-check-sign" />
                    Existing User
                  </Label>
                </FormGroup>

                <FormGroup check className="form-check-radio d-inline">
                  <Label check>
                    <Input
                      type="radio"
                      id="unlisted"
                      name="listed"
                      value="false"
                      checked={psxListing === false ? true : false}
                      onClick={(e) => {
                        setPsxListing(false);
                        setUserIs("");
                      }}
                    />
                    <span className="form-check-sign" />
                    New User
                  </Label>
                </FormGroup>
              </form>
            </div>
            <Row>
              {psxListing ? (
                <Col md="6">
                  <div className="">
                    <h6 className="mb-3">Select Existing User</h6>
                    <div className="form-group">
                      <label>Existing User</label>
                      <Select
                        value={selectedUser}
                        label={"Select"}
                        onChange={(e) => {
                          setUserIs(e?.value);
                          setName("");
                          setEmailAdd("");
                        }}
                        menuPortalTarget={document.body}
                        menuShouldBlockScroll={true}
                        isClearable={true}
                        isSearchable={true}
                        name="color"
                        options={renderUsersDropdown()}
                        styles={customStyles}
                        placeholder="Search and select user..."
                      />
                    </div>
                  </div>
                </Col>
              ) : (
                <Col md="6">
                  <div>
                    <h6 className="mb-3">Add New User</h6>
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                          if (e.target.value) {
                            setUserIs("");
                          }
                        }}
                        placeholder="Enter name"
                      />
                    </div>

                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        className="form-control"
                        value={emailAdd}
                        onChange={(e) => {
                          setEmailAdd(e.target.value);
                          if (e.target.value) {
                            setUserIs("");
                          }
                        }}
                        placeholder="Enter email"
                      />
                    </div>
                  </div>
                </Col>
              )}
            </Row>

            <div className="float-right mt-3">
              <Row>
                <Col>
                  <button
                    className="btn btn-primary"
                    disabled={
                      Boolean(Loading) || !(userIs || (name && emailAdd))
                    }
                    onClick={() => {
                      addEmailInList();
                    }}
                  >
                    {Loading ? (
                      <>
                        <span
                          className="spinner-border login-txt spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <span className="login-txt"> Loading...</span>
                      </>
                    ) : (
                      <span>Confirm</span>
                    )}
                  </button>
                </Col>
                <Col>
                  <button
                    className="btn btn-default"
                    onClick={() => {
                      setEmailAdd("");
                      setUserIs("");
                      setName("");
                      setShowModal(false);
                      setPsxListing(true);
                    }}
                  >
                    Cancel
                  </button>
                </Col>
              </Row>
            </div>
          </div>
        </Modal>

        {/* ------------- Company Signatory Modal ------------------------ */}
        <Modal
          centered={true}
          className=""
          dialogClassName="modal60w"
          show={companySignatoryModal ? true : false}
          size="lg"
          backdrop={true}
          onHide={() => {
            setCompanySignatoryModal(false);
            setEmailCompanySignatory("");
            setNameCompanySignatory("");
            setUserIs("");
            setPsxListing(true);
          }}
        >
          <div className="modal-header ">
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                setCompanySignatoryModal(false);
                setEmailCompanySignatory("");
                setNameCompanySignatory("");
                setUserIs("");
                setPsxListing(true);
              }}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h6 className="title title-up">Add Company Signatories</h6>
          </div>

          <div className="modal-body">
            <div className="mb-2">
              <form action="">
                <FormGroup check className="form-check-radio d-inline mr-3">
                  <Label check>
                    <Input
                      type="radio"
                      id="listed"
                      name="listed"
                      value="true"
                      checked={psxListing}
                      onClick={(e) => {
                        setPsxListing(true);
                        setNameCompanySignatory("");
                        setEmailCompanySignatory("");
                      }}
                    />
                    <span className="form-check-sign" />
                    Existing User
                  </Label>
                </FormGroup>

                <FormGroup check className="form-check-radio d-inline">
                  <Label check>
                    <Input
                      type="radio"
                      id="unlisted"
                      name="listed"
                      value="false"
                      checked={psxListing === false ? true : false}
                      onClick={(e) => {
                        setPsxListing(false);
                        setUserIs("");
                      }}
                    />
                    <span className="form-check-sign" />
                    New User
                  </Label>
                </FormGroup>
              </form>
            </div>
            <Row>
              {psxListing ? (
                <Col md="6">
                  <div className="">
                    <h6 className="mb-3">Select Existing User</h6>
                    <div className="form-group">
                      <label>Existing User</label>
                      <Select
                        value={selectedUser}
                        label={"Select"}
                        onChange={(e) => {
                          setUserIs(e?.value);
                          setNameCompanySignatory("");
                          setEmailCompanySignatory("");
                        }}
                        menuPortalTarget={document.body}
                        menuShouldBlockScroll={true}
                        isClearable={true}
                        isSearchable={true}
                        name="color"
                        options={renderUsersDropdown()}
                        styles={customStyles}
                        placeholder="Search and select user..."
                      />
                    </div>
                  </div>
                </Col>
              ) : (
                <Col md="6">
                  <div>
                    <h6 className="mb-3">Add New User</h6>
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={nameCompanySignatory}
                        onChange={(e) => {
                          setNameCompanySignatory(e.target.value);
                          if (e.target.value) {
                            setUserIs("");
                          }
                        }}
                        placeholder="Enter name"
                      />
                    </div>

                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        className="form-control"
                        value={emailCompanySignatory}
                        onChange={(e) => {
                          setEmailCompanySignatory(e.target.value);
                          if (e.target.value) {
                            setUserIs("");
                          }
                        }}
                        placeholder="Enter email"
                      />
                    </div>
                  </div>
                </Col>
              )}
            </Row>
            <div className="float-right">
              <Row>
                <Col>
                  <div className="">
                    <button
                      className="btn btn-primary"
                      disabled={
                        Boolean(Loading) ||
                        !(
                          userIs ||
                          (emailCompanySignatory && nameCompanySignatory)
                        )
                      }
                      onClick={() => {
                        submitAddAMCSignatory();
                      }}
                    >
                      {Loading ? (
                        <>
                          <span
                            className="spinner-border login-txt spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span className="login-txt"> Loading...</span>
                        </>
                      ) : (
                        <span>Confirm</span>
                      )}
                    </button>
                  </div>
                </Col>
                <Col>
                  <div className=" ">
                    <button
                      className="btn btn-default"
                      onClick={() => {
                        setCompanySignatoryModal(false);
                        setEmailCompanySignatory("");
                        setNameCompanySignatory("");
                        setUserIs("");
                        setPsxListing(true);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Modal>

        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />

              <Row>
                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Company Detail</h4>
                    </div>
                    <div className="card-body">
                      <div className="d-flex justify-content-center">
                        <div
                          style={{
                            width: "100px",
                            height: "100px",
                            position: "relative",
                          }}
                          onMouseEnter={() => setOnhover(true)}
                          onMouseLeave={() => setOnhover(false)}
                        >
                          {showImage ? (
                            <img
                              style={{
                                width: "100px",
                                height: "100px",
                              }}
                              className="User_image"
                              src={image}
                            />
                          ) : (
                            <svg
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                if (inputRefUser.current) {
                                  inputRefUser.current.click();
                                }
                              }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="100"
                              height="100"
                              viewBox="0 0 50 50"
                            >
                              <path
                                fill="#949494"
                                d="M25 2.008c-12.69 0-23 10.31-23 23s10.31 23 23 23 23-10.31 23-23-10.31-23-23-23m0 2c11.61 0 21 9.39 21 21a20.92 20.92 0 0 1-6.012 14.705c-1.83-1.343-4.06-2.017-5.949-2.69-1.064-.378-2.02-.753-2.719-1.171-.668-.4-1.04-.813-1.236-1.286-.092-1.146-.073-2.07-.066-3.16.12-.12.276-.205.4-.351.292-.345.59-.764.873-1.235.487-.807.84-1.795 1.04-2.797.302-.154.626-.187.872-.502.455-.58.762-1.396.899-2.533.12-1.004-.203-1.694-.62-2.224.449-1.465 1.003-3.795.815-6.205-.104-1.327-.438-2.662-1.24-3.772-.767-1.06-2.011-1.822-3.604-2.098C28.442 8.541 26.835 8 24.914 8h-.018c-4.302.079-7.078 1.86-8.267 4.576-1.13 2.583-.887 5.799-.076 9.147-.436.53-.778 1.233-.655 2.265.137 1.137.444 1.954.899 2.533.246.315.57.348.873.502.198 1.001.552 1.988 1.039 2.795.284.471.58.89.873 1.235.124.146.28.233.4.353.007 1.09.025 2.013-.066 3.16-.196.472-.567.884-1.234 1.286-.698.42-1.653.797-2.715 1.177-1.887.677-4.116 1.355-5.951 2.688A20.92 20.92 0 0 1 4 25.007c0-11.609 9.39-21 21-21m-.078 5.994c1.844.002 3.004.548 3.322 1.105l.244.428.487.067c1.256.174 1.958.662 2.46 1.357.503.695.783 1.666.868 2.756.17 2.18-.454 4.754-.85 5.945l-.252.756.682.414c-.07-.042.32.189.232.92-.106.89-.334 1.343-.486 1.537s-.218.17-.201.168l-.824.068-.088.823c-.076.706-.473 1.67-.938 2.441a8 8 0 0 1-.687.975c-.208.245-.43.397-.346.353l-.535.28V31c0 1.324-.054 2.407.086 3.95l.011.132.047.125c.394 1.06 1.215 1.806 2.139 2.36s1.983.952 3.076 1.341c1.801.641 3.678 1.272 5.11 2.203A20.9 20.9 0 0 1 25 46.008c-5.134 0-9.829-1.84-13.475-4.893 1.44-.926 3.32-1.559 5.118-2.203 1.092-.391 2.149-.793 3.07-1.348.921-.554 1.74-1.301 2.133-2.357l.047-.125.011-.133c.139-1.54.086-2.624.086-3.949v-.605l-.535-.282c.084.044-.138-.108-.346-.353a8 8 0 0 1-.687-.973c-.465-.771-.862-1.736-.938-2.441l-.088-.823-.824-.068c.016.001-.049.026-.2-.168-.153-.194-.38-.647-.487-1.537-.088-.732.307-.965.232-.92l.635-.385-.186-.72c-.86-3.312-.99-6.325-.105-8.348.884-2.02 2.655-3.303 6.46-3.375"
                              ></path>
                            </svg>
                          )}
                          {onhover && (
                            <div
                              style={{
                                width: "100px",
                                height: "100px",
                                borderRadius: "50%",
                                backgroundColor: "rgba(0,0,0.4)",
                                opacity: 0.6,
                                position: "absolute",
                                top: "0px",
                                left: "0px",
                              }}
                              className="d-flex flex-column align-items-center justify-content-center"
                            >
                              {showImage && (
                                <IoClose
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    cursor: "pointer",
                                    color: "white",
                                  }}
                                  onClick={() => {
                                    setShowImage(false);
                                    if (inputRefUser.current) {
                                      inputRefUser.current.value = "";
                                    }
                                    setProfilePicture("");
                                  }}
                                  className="mb-2"
                                />
                              )}
                              <FiUploadCloud
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                  color: "white",
                                }}
                                onClick={() => {
                                  if (inputRefUser.current) {
                                    inputRefUser.current.click();
                                  }
                                }}
                              />
                            </div>
                          )}
                        </div>
                        <input
                          type="file"
                          // accept="image/png, image/jpeg, image/jpg"
                          accept=".jpg,.jpeg,.png"
                          ref={inputRefUser}
                          onChange={(event) => {
                            const reader = new FileReader();
                            reader.onload = () => {
                              setImage(reader.result);
                              setShowImage(true);
                            };
                            if (event.target.files) {
                              let file = event.target.files[0];
                              if (file) {
                                let type = file.name
                                  .substring(file.name.lastIndexOf(".") + 1)
                                  ?.toLowerCase();
                                let imgSize = file.size;
                                if (imgSize > 1048576) {
                                  toast.error(
                                    "Image size should be less than 1MB"
                                  );
                                } else if (
                                  type === "png" ||
                                  type === "jpg" ||
                                  type === "jpeg"
                                ) {
                                  setProfilePicture(event.target.files[0]);
                                  reader.readAsDataURL(event.target.files[0]);
                                } else {
                                  toast.error("Invalid Format");
                                }
                              }
                            }
                          }}
                          style={{ display: "none" }}
                        />
                      </div>

                      <div className="form-group  ">
                        <div>
                          <label>
                            Company Code <span className="color-amber">*</span>
                          </label>
                        </div>
                        <div>
                          <div className=" ">
                            <input
                              type="text"
                              className={`form-control  w-100 ${
                                amcCodeError ? "required-border" : ""
                              }`}
                              value={amcCode}
                              onChange={(e) => {
                                var cleaned = e.target.value.replace(/\d/, "");
                                if (
                                  cleaned.length == 5 &&
                                  !cleaned.includes("-")
                                ) {
                                  // cleaned = cleaned + '-';
                                } else if (cleaned.length > 10) {
                                  cleaned = cleaned.substring(0, 10);
                                }
                                changeCodeValue(cleaned.toUpperCase());
                              }}
                            />
                          </div>
                          <div className="d-flex">
                            <span style={{ fontSize: "11px" }}>
                              {amcCodeError === "Invalid"
                                ? "Minimum 2 alphabets"
                                : ""}
                            </span>
                            {amcCodeError ? (
                              <span
                                className="ml-auto"
                                style={{ fontSize: "11px" }}
                              >
                                {amcCodeError}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="form-group  ">
                        <label>
                          Name of Company <span className="color-amber">*</span>
                        </label>
                        <div className=" ">
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              amcNameError ? "required-border" : ""
                            }`}
                            value={amcName}
                            onChange={(e) => {
                              setAmcName(e.target.value);
                              setAmcNameError("");
                            }}
                          />
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>
                          Type
                          <span className="color-amber">*</span>
                        </label>
                        <div>
                          <Select
                            value={selectedTypeFund}
                            label={"Select"}
                            onChange={(e) => {
                              setFundTypeIs(e?.value);
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderFundTypeDropdown()}
                            styles={customStyles}
                          />
                        </div>
                      </div>
                      <div className="form-group  ">
                        <label>NTN </label>
                        <div className="">
                          <input
                            type="text"
                            className={`form-control  w-100 `}
                            value={Ntn}
                            onChange={(e) => {
                              setNtn(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Bank Details</h4>
                    </div>
                    <div className="card-body">
                      <div className="form-group  ">
                        <label>
                          Account Title <span className="color-amber">*</span>
                        </label>
                        <div className="">
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              accTitleError ? "required-border" : ""
                            }`}
                            value={accTitle}
                            onChange={(e) => {
                              setAccTitle(e.target.value);
                              setAccTitleError("");
                            }}
                          />
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>
                          IBAN<span className="color-amber">*</span>
                        </label>
                        <div className="">
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              accNoError ? "required-border" : ""
                            }`}
                            value={accNo}
                            onChange={(e) => {
                              setAccNo(e.target.value);
                              setAccNoError("");
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Authorized Company Users</h4>
                    </div>
                    <div className="card-body">
                      <div className="form-group ">
                        {console.log("creator", creatorEmailArray)}
                        <label>
                          Authorizor <span className="color-amber">*</span>
                        </label>
                        <div className="multi-input">
                          <div
                            className={`d-flex  w-100 ${
                              amcSigError ? "required-border" : ""
                            }`}
                          >
                            <Dropdown>
                              <Dropdown.Toggle
                                className="input-sign"
                                variant="success"
                                id="dropdown-basic"
                              >
                                {creatorEmailArray.length} Added
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {creatorEmailArray.map((obj: any, i: any) => (
                                  <Dropdown.Item className="drop-item " key={i}>
                                    <div className="d-flex justify-content-between">
                                      <div className="mr-auto">{obj.email}</div>
                                      <div className="col-1">
                                        <BsX
                                          onClick={() =>
                                            removeCreatorCEmail(obj)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                            <div
                              className="icon icon-pos-xpt"
                              onClick={() => {
                                setShowModal(true);
                              }}
                            >
                              <button
                                type="button"
                                className="btn-icon btn-link like btn btn-primary btn-sm"
                              >
                                <i className="fa fa-user-plus fa-3x"> </i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>
                          Company Signatories{" "}
                          <span className="color-amber">*</span>
                        </label>
                        <div className="multi-input">
                          <div
                            className={`d-flex  w-100 ${
                              amcSigError ? "required-border" : ""
                            }`}
                          >
                            <Dropdown>
                              <Dropdown.Toggle
                                className="input-sign"
                                variant="success"
                                id="dropdown-basic"
                              >
                                {companySignatoryArray?.length} Added
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {companySignatoryArray?.map(
                                  (obj: any, i: any) => (
                                    <Dropdown.Item
                                      className="drop-item "
                                      key={i}
                                    >
                                      <div
                                        className="d-flex justify-content-between"
                                        style={{ fontSize: "15px" }}
                                      >
                                        <div
                                          className="mr-auto"
                                          style={{ fontSize: "15px" }}
                                        >
                                          <span style={{ color: "green" }}>
                                            Sig{obj?.role?.slice(-1)}
                                          </span>{" "}
                                          {obj?.email}
                                        </div>
                                        <div
                                          className="col-1"
                                          style={{ fontSize: "15px" }}
                                        >
                                          <BsX
                                            onClick={() => removeEmail(obj)}
                                          />
                                        </div>
                                      </div>
                                    </Dropdown.Item>
                                  )
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                            <div
                              className="icon icon-pos-xpt"
                              onClick={() => {
                                setCompanySignatoryModal(true);
                              }}
                            >
                              <button
                                type="button"
                                className="btn-icon btn-link like btn btn-primary btn-sm"
                              >
                                <i className="fa fa-user-plus fa-3x"> </i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <div className="form-group  ">
                                                <label>Concerned Officer {' '} <span className="color-amber">*</span></label>
                                                <div className="">
                                                    <select
                                                        className={`form-control  w-100 ${conOffericerError ? 'required-border' : ''
                                                            }`}
                                                        value={conOffericer}
                                                        onChange={(e) => {
                                                            setConOfficer(e.target.value);
                                                            setConOfficerError('');
                                                        }}
                                                    >
                                                        <option value="" defaultChecked hidden>
                                                            Select Officer
                                                        </option>
                                                        {renderofficersDropdown()}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="form-group  ">
                                                <label>Substitute Concerned Officer <span className="color-amber">*</span></label>
                                                <div className=" ">
                                                    <select
                                                        className={`form-control  w-100 ${SuboffericerError ? 'required-border' : ''
                                                            }`}
                                                        value={Suboffericer}
                                                        onChange={(e) => {
                                                            setSubOffericer(e.target.value);
                                                            setSubOffericerError('');
                                                        }}
                                                    >
                                                        <option value="" defaultChecked hidden>
                                                            Select Substitute
                                                        </option>
                                                        {renderSubOfficerDropdown()}
                                                    </select>
                                                </div>
                                            </div> */}
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Focal Person Detail</h4>
                    </div>
                    <div className="card-body">
                      <div className="form-group  ">
                        <label>Company Focal Person Name</label>
                        <div className="">
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              focalPerNameError ? "required-border" : ""
                            }`}
                            value={focalPerName}
                            onChange={(e) => {
                              setFocalPerName(
                                e.target.value.replace(/[^a-z^A-Z ]/, "")
                              );
                              setFocalPerNameError("");
                            }}
                          />
                          {/* {focalPerNameError ? <p className="error-labels error-message2">{focalPerNameError}</p> : ''} */}
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>Company Focal Person Email</label>
                        <div className="">
                          <input
                            type="text"
                            className={`form-control  w-100 ${
                              focalPerEmailError ? "required-border" : ""
                            }`}
                            value={focalPerEmail}
                            onChange={(e) => {
                              setFocalPerEmail(e.target.value);
                              setFocalPerEmailError("");
                            }}
                          />
                          {/* {focalPerEmailError ? <p className="error-labels error-message">{focalPerEmailError}</p> : ''} */}
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>Mobile</label>
                        <div className="">
                          <input
                            type="number"
                            className={`form-control  w-100 ${
                              mobileError ? "required-border" : ""
                            }`}
                            value={mobile}
                            onChange={(e) => {
                              var mob = e.target.value;
                              if (mob.length > 12) {
                                mob = mob.substring(0, 12);
                              }
                              setMobile(mob);
                              setMobileError("");
                            }}
                          />
                          {/* {mobileError ? <p className="error-labels error-message2">{mobileError}</p> : ''} */}
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>Phone</label>
                        <div className="">
                          <input
                            type="number"
                            className={`form-control  w-100 ${
                              phoneError ? "required-border" : ""
                            }`}
                            value={phone}
                            onChange={(e) => {
                              var num = e.target.value;
                              if (num.length > 12) {
                                num = num.substring(0, 12);
                              }
                              setPhone(num);
                              setPhoneError("");
                            }}
                          />
                          {/* {phoneError ? <p className="error-labels error-message">{phoneError}</p> : ''} */}
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <div className=" ">
                <button
                  className="btn btn-primary mb-3"
                  onClick={UpdateCompany}
                  disabled={Boolean(Loading)}
                >
                  {Loading ? (
                    <>
                      <span
                        className="spinner-border login-txt spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span className="login-txt"> Loading...</span>
                    </>
                  ) : (
                    <span>Update</span>
                  )}
                </button>
              </div>
              {renderModalPopup()}
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default EditCompany;
